import React, { useState } from "react";
import { RevealingContext } from "./textRevealState/RevealingContext";
import { SetRevealingIdsContext } from "./textRevealState/SetRevealingIdsContext";
import type { RevealingIds } from "./textRevealState/RevealingIds";

export const TextRevealProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // Keyed by part rather than counted, so a double-report or a missed cleanup
  // cannot leave the strip hidden on a phantom reveal.
  const [ids, setIds] = useState<RevealingIds>(() => new Set());

  return (
    <SetRevealingIdsContext.Provider value={setIds}>
      <RevealingContext.Provider value={ids.size > 0}>
        {children}
      </RevealingContext.Provider>
    </SetRevealingIdsContext.Provider>
  );
};
